var map = {
	"./en.json": "UpdR",
	"./fr.json": "FiWC",
	"./ja.json": "1ccB",
	"./zh.json": "MvI0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5s5S";


//////////////////
// WEBPACK FOOTER
// ./src/i18n [A-Za-z0-9-_,\s]+\.json$/
// module id = 5s5S
// module chunks = 1